import { css } from '@emotion/react'

export const icon = css`
    display: flex;
    align-items: center;
    justify-content: center;
`
